module.exports = __webpack_public_path__ + "static/media/card-project5.516bb2de.jpg";